import Amplify, { Auth } from 'aws-amplify';
import { whiteLabel } from 'Whitelabel';
import {NotificationManager} from 'react-notifications';
import { apiCall } from 'CommonFunctions';

import {
   LOGIN_USER,
   LOGIN_USER_SUCCESS,
   LOGIN_USER_FAILURE,
   LOGOUT_USER,
   SAVE_ADMIN,
   CHANGE_AUTH_PAGE,
   SAVE_EMAIL,
   LOADING_SPINNER,
   SAVE_USER_NAME,
   SAVE_COUNTRY
} from './types';

const awsConfig = whiteLabel('awsConfig');
const restrictedList = whiteLabel('adminPages').whitelist;

export const checkRestrictedList = async () => {
  const areWeAllowed = await apiCall('checkRestrictedList');
  return restrictedList ? areWeAllowed.results : true;
}


Amplify.configure(awsConfig);

export const saveUserName = (data) => {
  return {
    type: SAVE_USER_NAME,
    payload: data,
  };
};

export const saveCountry = (data) => {
  return {
    type: SAVE_COUNTRY,
    payload: data,
  };
};

export const saveAuthLoading = (data) => {
  return {
    type: LOADING_SPINNER,
    payload: data,
  };
};

export const saveEmail = (data) => {
  return {
    type: SAVE_EMAIL,
    payload: data.trim(),
  };
};

export const changeMainAuthPage = (data) => {
  return {
    type: CHANGE_AUTH_PAGE,
    payload: data,
  };
};


//added by oh7even
export const signinUserInCognito = (email, password, history) => async function (dispatch) {
   try {
      dispatch({ type: LOGIN_USER });
      const data = await Auth.signIn(email, password);
      const userInfo = await Auth.currentAuthenticatedUser();


      //Save whether we are admin or not
      if (userInfo.signInUserSession.idToken.payload['cognito:groups'] !== undefined) {
        if (userInfo.signInUserSession.idToken.payload['cognito:groups'][0] === 'admin') {
          //console.log('in admin group');
          localStorage.setItem("admin", true);
          dispatch({ type: SAVE_ADMIN, payload: true});
        }
      } else {
        //console.log('not in admin group');
        localStorage.setItem("admin", false);
        dispatch({ type: SAVE_ADMIN, payload: false});
      }

      const accessToken = data.signInUserSession.accessToken.jwtToken;
      const idToken = data.signInUserSession.idToken.jwtToken;
      localStorage.setItem("user_id", email);
      localStorage.setItem("user_name", userInfo.attributes.name);
      localStorage.setItem('access_token', accessToken);
      localStorage.setItem('auth_token', idToken);

      const areWeAllowed = await checkRestrictedList();
      //console.log('areWeAllowed', areWeAllowed);
      if (areWeAllowed === false) {
        alert('Please contact support to make sure you have been added to the platform');
        dispatch({ type: LOGIN_USER_FAILURE });
        dispatch({ type: LOADING_SPINNER, payload: false});
      } else {
        dispatch({ type: LOGIN_USER_SUCCESS, payload: email});
        history.push('/');
      }

   } catch (error) {
     //console.log('error', error)
      dispatch({ type: LOGIN_USER_FAILURE });
      if (error.response === undefined) {
        //console.log('here 1')

        if (error.code === 'UserNotConfirmedException') {
          console.log('user.email', email)
          //Here we resend the confirmation code for the email address
          Auth.resendSignUp(email)
          .then(success => {
              const r = window.alert('Please confirm email before continuing (We have just sent you a new code)')
              //alert('Please confirm email before continuing (We have just sent you a new code)');
              dispatch({ type: CHANGE_AUTH_PAGE, payload: 'confirmEmail'});
              dispatch({ type: LOADING_SPINNER, payload: false});
          })
          .catch(error => {
            console.log('error', error);
            const r = window.alert(error.message)
            dispatch({ type: LOADING_SPINNER, payload: false});
          });

        } else {
          const r = window.alert(error.message)
          dispatch({ type: LOADING_SPINNER, payload: false});
        }
      } else {
        const r = window.alert(error.response.data)
        dispatch({ type: LOADING_SPINNER, payload: false});
      }
   }
}

export const logoutUserFromCognito = () => async function (dispatch) {
  console.log('in logoutUserFromCognito');
   try {

      await Auth.signOut();

      dispatch({ type: LOGOUT_USER });

      localStorage.removeItem('user_id');
      localStorage.removeItem("user_name");
      localStorage.removeItem('access_token');
      localStorage.removeItem('auth_token');
      //NotificationManager.success('User Logout Successfully');
   } catch (error) {
      alert(error.response === undefined ? error.message : error.response.data);
   }
}
